import { Component, EventEmitter, Input, Output } from "@angular/core";
import { detectMobilePlatform } from "../../shared/utils/mobile-platform.utils";

@Component({
  selector: "app-guest-app-downloads",
  templateUrl: "./guest-app-downloads.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestAppDownloadsComponent {
  public readonly mobilePlatform = detectMobilePlatform();
  public readonly showAndroidLink = this.mobilePlatform === null || this.mobilePlatform === "android";
  public readonly showIosLink = this.mobilePlatform === null || this.mobilePlatform === "ios";
  @Input() public title = "";
  @Input() public description = "";
  @Input() public openLabel = "";
  @Input() public openUrl = "";
  @Input() public androidUrl = "";
  @Input() public iosUrl = "";
  @Input() public showOpenLink = false;
  @Input() public opening = false;
  @Output() public openRequested = new EventEmitter<void>();
}
